import { Grid, Typography } from "@mui/material";

type TypographyTextProps = {
  label: string;
  value?: string | null;
};

export const TypographyText = ({ label, value }: TypographyTextProps) => {
  return (
    <Grid item xs={12} sm={4}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>

      <Typography variant="body2" fontWeight={500}>
        {value ?? "-"}
      </Typography>
    </Grid>
  );
};